<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-staff-transfer`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.83 23.143l5.079 5.302a.335.335 0 010 .46.305.305 0 01-.22.095H44.4C42.158 38.185 33.875 45 24 45S5.842 38.184 3.599 29h4.148C9.882 35.949 16.351 41 24 41c7.648 0 14.117-5.051 16.253-12H37.31a.318.318 0 01-.311-.325c0-.086.033-.169.091-.23l5.079-5.302a.453.453 0 01.66 0zM25.888 27C29.55 27 33 29.488 33 33.172a.95.95 0 01-.947.953H15.947a.95.95 0 01-.947-.953C15 29.488 18.46 27 22.123 27h3.764zm-1.743-12a5.145 5.145 0 110 10.29 5.145 5.145 0 010-10.29zM.311 19H10.69c.082 0 .162.034.22.095a.336.336 0 01.044.4l-.044.06-5.079 5.302a.452.452 0 01-.587.063l-.073-.063-5.079-5.302a.332.332 0 01.149-.546L.31 19H10.69.31zM24 3c9.875 0 18.158 6.816 20.401 16h-4.148C38.118 12.052 31.649 7 24 7 16.352 7 9.883 12.051 7.747 19H3.6C5.842 9.815 14.125 3 24 3z"/></svg>
</template>
<script>

export default {
  name: 'IconStaffTransfer',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
